import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { memo } from 'react';
import classnames from 'classnames';
import ExpandIcon from 'Shared/assets/icons/dropdown.svg';
import DatasetItem from '../DatasetItem/DatasetItem';
import styles from './DatasetGroup.css';
const DatasetGroup = ({ datasets, id, name, onClick: handleClick, onChange, onHover: handleHover, selectedDatasetId, isOpen = false, className, }) => {
    const iconClassName = classnames(styles.icon, {
        [styles.collapseIcon]: isOpen,
    });
    const listClassName = classnames(styles.list, {
        [styles.collapsedList]: !isOpen,
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ role: "button", className: classnames(styles.container, className), onClick: () => handleClick(id), "data-testid": "DatasetControl.datasetGroup" }, { children: [_jsx(ExpandIcon, { className: iconClassName }, void 0), _jsx("p", Object.assign({ className: styles.title }, { children: name }), void 0)] }), void 0), isOpen && (_jsx("ul", Object.assign({ className: listClassName, "aria-label": name }, { children: datasets.map(({ id: datasetId, name: datasetName, description, versionId, }) => (_jsx(DatasetItem, { versionId: versionId, name: datasetName, description: description, onChange: onChange, onHover: handleHover, isSelected: datasetId === selectedDatasetId }, datasetId))) }), void 0))] }, void 0));
};
export default memo(DatasetGroup);
